'use client';

import { CheckCircle, Download, ExternalLink, Calendar, Clock } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { formatDate, formatTime } from '@/lib/audit/pro-report-utils';
import styles from '@/components/audit/ProReportResults.module.css';

interface FallbackHeaderProps {
  url: string;
  timestamp: string;
  locale?: string;
  onDownloadPDF: () => void;
}

export function FallbackHeader({
  url,
  timestamp,
  locale = 'en',
  onDownloadPDF,
}: FallbackHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.headerBadge}>
          <span className={styles.badgeIcon}>
            <CheckCircle size={14} />
          </span>
          Expert UX Analysis Complete
        </div>

        <h1 className={styles.title}>Your UX Audit Report</h1>

        <a href={url} target="_blank" rel="noopener noreferrer" className={styles.urlLink}>
          <span className={styles.urlText}>{url}</span>
          <ExternalLink size={14} />
        </a>

        <div className={styles.headerMeta}>
          <span className={styles.metaItem}>
            <Calendar size={14} />
            {formatDate(timestamp, locale)}
          </span>
          <span className={styles.metaItem}>
            <Clock size={14} />
            {formatTime(timestamp, locale)}
          </span>
        </div>
      </div>

      <div className={styles.headerActions}>
        <Button onClick={onDownloadPDF} className={styles.downloadButton}>
          <Download size={18} />
          Download PDF
        </Button>
      </div>
    </header>
  );
}
